import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormat, dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaRegEye } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker, Input, Select, timeFormat } from "common/InputForm";
import { toast } from "sonner";

import { postListApi, removePostApi, updatePostStatus } from "services/post";
import { userPlaceholder } from "assets/icons";
import "./postManagement.scss";
import { charLimit } from "utils/formValidator";

const PostManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [postList, setPostList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  let hashtag = searchParams.get("title") || "";
  const limits = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const createdByValue = searchParams.get("createdBy") || "";
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const batchValue = searchParams.get("batch") || "";
  const batchId = searchParams.get("batchId") || "";
  const groupValue = searchParams.get("group") || "";
  const trendStatusValue = searchParams.get("isTrend") || "";
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();

  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ postId: id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removePostApi(selected.postId);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        searchParams.delete("page");
        postListHandler();
        setDeleteModal(false);
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (postId, status) => {
    setSelected({
      ...selected,
      postId,
      status: status === "true" ? "false" : "true",
      action: "changeStatus",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updatePostStatus(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        postListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("createdBy");
    searchParams.delete("endDate");
    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  //-----------status-------------
  const handleCreater = (event) => {
    const value = event.target.value;
    searchParams.set("createdBy", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  const handleTrendStatus = (event) => {
    const value = event?.target?.value;
    searchParams.set("isTrend", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  // student list handler
  const postListHandler = async (
    page = activePage,
    limit = limits,
    search = debouncedValue,
    sortField = fieldName || "",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue,
    batchStatus = batchValue,
    batch = batchId,
    group = groupValue,
    createdBy = createdByValue,
    hashTags = hashtag
  ) => {
    try {
      onShow();
      const sendData = {
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,
        batchStatus,
        batch,
        group,
        createdBy,
        hashTags,
      };

      if (trendStatusValue) {
        sendData.isTrend = trendStatusValue;
      }
      const res = await postListApi(sendData);
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setPostList(res.data?.data?.posts);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "postList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    postListHandler();
  }, [
    // searchParams,
    debouncedValue,
    fieldName,
    direaction,
    activePage,
    searchStartDate,
    searchEndDate,
    statusValue,
    batchValue,
    batchId,
    groupValue,
    hashtag,
    createdByValue,
    trendStatusValue,
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  return (
    <>
      <div className="student_management post_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Post Management</h3>

            <div className="d-flex">
              <Link
                to="/post-management/add"
                className="MuiButtonBase-root MuiButton-root MuiButton-contained button mx-2"
              >
                Add Post
              </Link>
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />

              {/* <div className="d-flex align-items-center"> */}
              <select
                className="input form-control"
                value={statusValue}
                onChange={handleStatus}
              >
                <option value={""}>Select Status</option>
                <option value="true">Active</option>
                <option value="false">In Active</option>
              </select>
              <select
                className="input form-control"
                value={createdByValue}
                onChange={handleCreater}
              >
                <option value={""}>Select Created By</option>
                <option value="admin">Admin</option>
                <option value="user">User</option>
              </select>
              <select
                className="input form-control"
                value={trendStatusValue}
                onChange={handleTrendStatus}
              >
                <option value={""}>All Post</option>
                <option value="true">Trending Posts</option>
              </select>
              <DatePicker
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
              <DatePicker
                name="endDate"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />

              <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th>S.No.</th>

                    <th>Image </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("userInfo.name")}
                    >
                      Name
                      <span className="shorting">
                        {fieldName === "userInfo.name"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th>Date </th>
                    <th className="nowrap">Time</th>

                    <th className="nowrap">Caption </th>
                    <th className="text-center">Status</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {postList && postList.length > 0 ? (
                    postList?.map((data, index) => {
                      console.log(data, "datvva");
                      return (
                        <tr key={++index}>
                          {/* <td>{index + 1}</td> */}
                          <td>{++index + (activePage - 1) * 10}</td>
                          <td className="nowrap">
                            {data.images && data.images.length > 0 ? (
                              <button
                                type="button"
                                onClick={() => {
                                  setImagePreview(true);
                                  setImageUrl(data.images[0]?.url);
                                }}
                              >
                                <img
                                  src={
                                    data.images[0]?.url
                                      ? data.images[0].url
                                      : userPlaceholder
                                  }
                                  className="poster"
                                  alt=""
                                />
                              </button>
                            ) : (
                              data.video && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setImagePreview(true);
                                    setImageUrl(data?.video?.thumb);
                                  }}
                                >
                                  <img
                                    src={
                                      data?.video?.thumb
                                        ? data?.video?.thumb
                                        : userPlaceholder
                                    }
                                    className="poster"
                                    alt=""
                                  />
                                </button>
                              )
                            )}
                          </td>

                          <td>{data?.userInfo?.name}</td>

                          <td className="nowrap">
                            {dateFormat(data?.createdAt)}
                          </td>
                          <td className="nowrap">
                            {timeFormat(data?.createdAt)}
                          </td>
                          <td className="nowrap">
                            {data?.caption.length > 50 ? (
                              <div className="d-flex wrap_td_span">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: charLimit(data?.caption, 30),
                                  }}
                                ></p>
                                &nbsp;
                                <button
                                  className="readMore"
                                  onClick={() => {
                                    setDescriptionModal(true);
                                    setDescription(
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: data?.caption,
                                        }}
                                      ></p>
                                    );
                                  }}
                                >
                                  <b>Read More</b>
                                </button>
                              </div>
                            ) : (
                              <div className="d-flex wrap_td_span">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: data?.caption,
                                  }}
                                ></p>
                              </div>
                            )}
                          </td>
                          <td className="text-center">
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                statusHandler(
                                  data._id,
                                  data?.status.toString()
                                );
                              }}
                            >
                              <SwitchButton status={data?.status.toString()} />
                            </Link>
                          </td>
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                to={`/post-management/detail/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEye />
                              </Link>

                              <Link
                                to={`/post-management/edit/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Post data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete Class Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Post?"
        title="Delete Post"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Post?"
        title="Change Post"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default PostManagement;
